import { KNOWN_ERROR_MESSAGES } from '../api/constants';

import { ClientId } from './constants';

export const getKnownErrorMessageByClientId = (clientId?: ClientId): string => {
  return (clientId && KNOWN_ERROR_MESSAGES[`${clientId}_error`]) || KNOWN_ERROR_MESSAGES['default_error'];
};
